import { DocumentReviewLayout } from '~/widgets/document-review-layout'
import { PaymentDepositContent } from './payment-deposit-content'

/**
 * Payment Deposit page — first EOB step. Collects payment type, amounts, and deposit
 * confirmation before navigating to the duplication check step.
 *
 * This is a `page/` because it's a route component for `/documents/:documentKey/payment-deposit`.
 */
export function DocumentPaymentDepositPage() {
  return (
    <DocumentReviewLayout step="Payment Deposit">
      <PaymentDepositContent />
    </DocumentReviewLayout>
  )
}
